import { UntypedFormBuilder } from '@angular/forms';
import { FormGroupBase } from '../../ng-shared/components/form/form-group-base'
import { CampoFormulario} from '../../ng-shared/components/form/campo-formulario'

export class AcessoFormGroup  extends FormGroupBase
{
    public static readonly codigoAcesso: CampoFormulario = new CampoFormulario({name: 'codigoAcesso', placeHolder: 'Código de Acesso', required: true, maxLength: 6});
    public static readonly login: CampoFormulario = new CampoFormulario({name: 'login', placeHolder: 'Login', required: true, maxLength: 100});
    public static readonly senha: CampoFormulario = new CampoFormulario({name: 'senha', placeHolder: 'Senha', required: true, maxLength: 100});
        
    
    public criarFormGroup(formBuilder: UntypedFormBuilder) {
        return formBuilder.group({
            [AcessoFormGroup.codigoAcesso.name]: ['', AcessoFormGroup.codigoAcesso.getValidators()],
            [AcessoFormGroup.login.name]: ['', AcessoFormGroup.login.getValidators()],
            [AcessoFormGroup.senha.name]: ['', AcessoFormGroup.senha.getValidators()]
        });
    }

    constructor(formBuilder: UntypedFormBuilder)
    {
        super(formBuilder);
    }

    get campos() { return AcessoFormGroup; }

}